export const withProtocol = (url: string): string => {
  const regexp = /^((?:f|ht)tps?:)?\/\//
  return regexp.test(url) ? url : 'https://' + url
}
